/**
 * Created by rodolfo.rivas on 16/05/17.
 */
import {Docker} from '../../layout/recursos/modelo/docker';
import {Router} from '@angular/router';

declare var $: any;
declare var swal: any;

export class UtilConfig {
    static DEFAULT_MESSAGE_ERROR = 'Intente nuevamente más tarde';
    
    CONST_ORIGEN_LDAP = 'EXTERNO';

    TOKEN_KEY = 'XXWdfsfXXXX';
    URL_SAVE = 'wwWdfsfXXXX';
    ESCON_CUSTOMER = '1';
    SUPER_ADMINISTRADOR = 1;
    ACCOUNT_MANAGER = -1;
    SUPER_ACCOUNT_MANAGER = 0;

    USER_KEY = 'sWwbooBrrXX';

    URL_WS_BACKEND = 'https://escondatagate.sovos.com/wsBackend';
    //URL_WS_BACKEND = 'https://test.escondatagate.net/wsBackend';
    //URL_WS_BACKEND = 'https://calidad.escondatagate.net/wsBackend';
    //URL_WS_BACKEND = 'https://facturadorelectronicobcp.escondatagate.com/wsBackend';
    //URL_WS_BACKEND = 'http://localhost:8080/wsBackend';
    // URL_WS_BACKEND = 'https://edg.aski.com.co/wsBackend';
    // URL_WS_BACKEND = 'http://172.18.0.25:8080/wsBackend';
    // URL_WS_BACKEND = 'http://192.168.1.57:8080/wsBackend';

    CONFIG_ES_CALENDAR = {
        firstDayOfWDeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mie', 'jue', 'vie', 'sab'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
    };


    CHART_TYPES = [
        'lineChart',
        'discreteBarChart',
        'pieChart',
        'scatterChart',
        'multiBarChart',
        'candlestickBarChart',
        'ohlcBarChart',
        'boxPlotChart',
        'donutChart',
        'multiBarHorizontalChart',
        'linePlusBarWithFocusChart',
        'forceDirectedGraph'
    ];

    OPTION_DOCUMENTO = {
        chart: {
            type: 'multiBarChart',
            height: 150,
            margin: {
                top: 60,
                right: 20,
                bottom: 45,
                left: 65
            },
            clipEdge: true,
            duration: 500,
            stacked: false,
            xAxis: {
                axisLabel: '',
                showMaxMin: true
            },
            yAxis: {
                axisLabel: 'Transacciones',
                axisLabelDistance: 0
            }
        }
    };

    OPTION_DONUT = {
        chart: {
            type: 'pieChart',
            height: 250,
            donut: true,
            x: function (d) {
                return d.key;
            },
            y: function (d) {
                return d.y;
            },
            showLabels: true,
            pie: {
                startAngle: function (d) {
                    return d.startAngle / 2 - Math.PI / 2;
                },
                endAngle: function (d) {
                    return d.endAngle / 2 - Math.PI / 2;
                }
            },
            legendPosition: 'bottom',
            duration: 500,
            color: ['#003333', '#990000']
        }
    };

    OPTION_GENERAL = {
        chart: {
            type: 'multiBarChart',
            height: 400,
            margin: {
                top: 90,
                right: 20,
                bottom: 45,
                left: 65
            },
            clipEdge: true,
            //staggerLabels: true,
            duration: 500,
            stacked: false,
            xAxis: {
                axisLabel: '',
                showMaxMin: true
            },
            yAxis: {
                axisLabel: 'Transacciones',
                axisLabelDistance: 0
            }
        }
    };


    visualizarSalir() {
        $('#modal1').addClass('open');
    }

    ocultarSalir() {
        $('#modal1').removeClass('open');
    }


    getJwtToken() {
        if (this.getCurrentUser() != null)
            return sessionStorage.getItem(this.TOKEN_KEY + this.getCurrentUser().id);
        else
            return null;
    }

    setJwtToken(token) {
        if (token != undefined && token != '' && token != null)
            sessionStorage.setItem(this.TOKEN_KEY + this.getCurrentUser().id, token);
    }


    saveUrl(url) {
        if (url != undefined && url != '' && url != null)
            sessionStorage.setItem(this.URL_SAVE + this.getCurrentUser().id, url);
    }

    getUrlSave() {
        return sessionStorage.getItem(this.URL_SAVE + this.getCurrentUser().id);
    }

    removeJwtToken() {
        sessionStorage.removeItem(this.TOKEN_KEY + this.getCurrentUser().id);
    }

    removeSession() {
        sessionStorage.clear();
        localStorage.clear();
    }

    createAuthorizationTokenHeader(): string {
        let token = this.getJwtToken();

        if (token) {
            return token;
        } else {
            return '';
        }
    }

    setCurrentUser(user) {
        sessionStorage.setItem(this.USER_KEY, JSON.stringify(user));
    }


    getCurrentUser() {
        let user = sessionStorage.getItem(this.USER_KEY);
        if (user != null) {
            let usuario = JSON.parse(user);
            return usuario;
        }
        return null;
    }

    removeCurrentUser() {
        sessionStorage.removeItem(this.USER_KEY);
    }

    verificarAuthorities(authorities) {

        let user = this.getCurrentUser();
        // Resetea los permisos sobre el componente
        $.each(authorities, function (key, value) {
            authorities[key] = false;
        });

        if (user != null) {
            // Setea los permisos sobre el componente
            $.each(authorities, function (key, value) {
                if (user.permisos.includes(key)) {
                    authorities[key] = true;
                }
            });
        }
        return authorities;
    }


    hasAuthorities(authorities): boolean {
        var permiso = false;
        let user = this.getCurrentUser();
        if (user != null) {
            // Setea los permisos sobre el componente
            $.each(authorities, function (pos, item) {
                if (user.permisos.toString().indexOf(item) != -1)
                    permiso = true;
            });
        }
        return permiso;
    }


    getFondo() {
        let fondo = localStorage.getItem('fondo' + this.getCurrentUser().id);
        if (fondo == null) {
            fondo = 'fondo1';
        }
        return fondo;
    }

    setFondo(fondo) {
        if (fondo != undefined && fondo != '' && fondo != null)
            localStorage.setItem('fondo' + this.getCurrentUser().id, fondo);
    }

    getColorIcons() {
        return localStorage.getItem('colorIcons' + this.getCurrentUser().id);
    }

    setColorIcons(value) {
        return localStorage.setItem('colorIcons' + this.getCurrentUser().id, value);
    }

    getColorTitle() {
        return localStorage.getItem('colorTitle' + this.getCurrentUser().id);
    }

    setColorTitle(value) {
        return localStorage.setItem('colorTitle' + this.getCurrentUser().id, value);
    }

    getColorText() {
        return localStorage.getItem('colorText' + this.getCurrentUser().id);
    }

    setColorText(value) {
        return localStorage.setItem('colorText' + this.getCurrentUser().id, value);
    }

    setProductList(value) {
        return localStorage.setItem('productList' + this.getCurrentUser().id, JSON.stringify(value));
    }

    getProductList() {
        return localStorage.getItem('productList' + this.getCurrentUser().id);
    }

    setSerieEmisor(value) {
        return localStorage.setItem('emisorConfig' + this.getCurrentUser().id, JSON.stringify(value));
    }

    getSerieEmisor() {
        return localStorage.getItem('emisorConfig' + this.getCurrentUser().id);
    }

    setReceptores(value) {
        return localStorage.setItem('receptores' + this.getCurrentUser().id, JSON.stringify(value));
    }

    getReceptores() {
        return localStorage.getItem('receptores' + this.getCurrentUser().id);
    }

    getDocker() {
        let docker = localStorage.getItem('docker' + this.getCurrentUser().id);
        if (docker != null) {
            let docker_obj = JSON.parse(docker);
            return docker_obj;
        } else {
            let dockerDefault: Docker[] = [];
            dockerDefault.push(new Docker('Usuario', 'boss-1.png', 'usuario', false, 'ROLE_USUARIO_LISTAR'));
            dockerDefault.push(new Docker('Enviado', 'check-box.png', 'logEmisor', false, 'VISIBLE'));
            dockerDefault.push(new Docker('Reportes', 'bars-chart.png', 'log', false, 'ROLE_REPORTE_LISTAR'));
            dockerDefault.push(new Docker('Indicadores', 'line-chart.png', 'indicadores', false, 'VISIBLE'));
            dockerDefault.push(new Docker('Sunat', 'contract.png', 'logSunat', false, 'ROLE_LOG_SUNAT_LISTAR'));
            dockerDefault.push(new Docker('Emisor', 'flats.png', 'emisor', false, 'ROLE_CUSTOMER_LISTAR'));
            this.setDocker(dockerDefault);
            return dockerDefault;
        }
    }

    setDocker(docker) {
        localStorage.setItem('docker' + this.getCurrentUser().id, JSON.stringify(docker));
    }

    getActivoNotEscritorio() {
        let notificacionEscritorio = localStorage.getItem('notificacionEscritorio' + this.getCurrentUser().id);
        if (notificacionEscritorio != null) {
            let notificacionEscritorio_obj = JSON.parse(notificacionEscritorio);
            return notificacionEscritorio_obj;
        } else {
            let notificacionEscritorio_obj = false;
            this.setActivoNotEscritorio(notificacionEscritorio_obj);
            return notificacionEscritorio_obj;
        }
    }

    setActivoNotEscritorio(notificacionEscritorio) {
        localStorage.setItem('notificacionEscritorio' + this.getCurrentUser().id, notificacionEscritorio);
    }


    getActivoNotAudio() {
        let notificacionAudio = localStorage.getItem('notificacionAudio' + this.getCurrentUser().id);
        if (notificacionAudio != null) {
            let notificacionAudio_obj = JSON.parse(notificacionAudio);
            return notificacionAudio_obj;
        } else {
            let notificacionAudio_obj = false;
            this.setActivoNotAudio(notificacionAudio_obj);
            return notificacionAudio_obj;
        }
    }

    setActivoNotAudio(notificacionAudio) {
        localStorage.setItem('notificacionAudio' + this.getCurrentUser().id, notificacionAudio);
    }

    manejoError(error: any, router: any) {

        if (error.toLowerCase() == 'internal server error' ||
            error.toLowerCase() == 'server error') {
            swal(
                'Error al tratar de realizar acción!',
                'Intente nueva mente más tarde',
                'error'
            );
            router.navigate(['/content', {outlets: {'second': ['home']}}]);
        }

        if (error.status == 404 ||
            error.status == 405 ||
            error.status == 500 ||
            error.status == 502) {
            swal(
                'Error al tratar de realizar acción!',
                'Intente nueva mente más tarde',
                'error'
            );
            router.navigate(['/content', {outlets: {'second': ['home']}}]);
        }

        if (error == 'Unauthorized' ||
            error.status == 403 ||
            error.status == 401 ||
            error.status == 402) {
            swal({
                title: 'Se va a redireccionar a la pantalla de acceso',
                text: 'No posee permisos para realizar acción. Se redireccionara al login.',
                type: 'error',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 3000
            });

            setTimeout(() => {
                this.removeJwtToken();
                this.removeCurrentUser();
                router.navigate(['/']);
            }, 4000);

            return false;
        }

        if (error.type == 3) {
            swal(
                'Error al tratar de realizar acción!',
                'Problemas de conexión, intente nuevamente más tarde.',
                'error'
            );
            router.navigate(['/content', {outlets: {'second': ['home']}}]);
        }

        if (error.type == 2) {
            swal(
                'Error al tratar de realizar acción!',
                error.json().message,
                'error'
            );
        }
    }


    //Ventana de error al consumir servicios web
    abrirModalErrorParaServicios(err, titleIfCodeserver, router: Router) {
        if (err == 'Unauthorized' ||
            err.status == 401 ||
            err.status == 402 ||
            err.status == 403 ||
            err.status == 405) {

            let msj = '';
            if (err.message.indexOf('Full authentication is required to access this resource') != -1) {
                msj = 'No tiene una sesión activa.';
            } else {
                msj = err.message;
            }

            swal({
                title: 'Se va a redireccionar a la pantalla de login',
                text: msj,
                type: 'error',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 4000
            });

            setTimeout(() => {
                this.removeJwtToken();
                this.removeCurrentUser();
                router.navigate(['/']);
            }, 2000);
        } 
        
       else if(err.status == 502) {
            swal(
                'Error al tratar de realizar acción!',
                 UtilConfig.DEFAULT_MESSAGE_ERROR,
                'error'
            );
            router.navigate(['/content', {outlets: {'second': ['home']}}]);
        }
        else {
            if (err.status == -1) {
                swal({
                    title: titleIfCodeserver,
                    text: UtilConfig.DEFAULT_MESSAGE_ERROR,
                    type: 'error',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 3000
                });

                setTimeout(() => {
                    router.navigate(['/content', {outlets: {'second': ['home']}}]);
                }, 2000);
                return false;
            }
            swal(
                titleIfCodeserver,
                UtilConfig.DEFAULT_MESSAGE_ERROR,
                'error'
            );
        }
    }

    poseeEmisor() {
        var posee: boolean = false;
        var aplicacionesEmisor = this.getCurrentUser().customer.applications;
        $.each(aplicacionesEmisor, (pos, item) => {
            if (item == 'EMISOR')
                posee = true;
        });
        return posee;
    }


    permisosXrol(ItemSelected) {
        var usuarioSession = this.getCurrentUser();

        if (usuarioSession.rol.id == this.SUPER_ADMINISTRADOR) {
            return true;

        } else if (usuarioSession.rol.id == this.SUPER_ACCOUNT_MANAGER) {
            if (ItemSelected.rol.id == this.SUPER_ADMINISTRADOR)
                return false;
            else
                return true;
        } else if (usuarioSession.rol.id == this.ACCOUNT_MANAGER) {
            if (ItemSelected.rol.id == this.SUPER_ADMINISTRADOR)
                return false;

            if (ItemSelected.rol.id == this.SUPER_ACCOUNT_MANAGER)
                return false;

            if (ItemSelected.rol.id == this.ACCOUNT_MANAGER)
                return true;
        }

        if (ItemSelected.rol.id == this.SUPER_ADMINISTRADOR)
            return false;
        else if (ItemSelected.rol.id == this.SUPER_ACCOUNT_MANAGER)
            return false;
        else if (ItemSelected.rol.id == this.ACCOUNT_MANAGER)
            return false;

        return true;
    }

    removeAllBlankOrNull(JsonObj) {
        $.each(JsonObj, (key, value) => {
            if (value === '' || value === null) {
                delete JsonObj[key];
            } else if (typeof (value) === 'object') {
                JsonObj[key] = this.removeAllBlankOrNull(value);
            }
        });
        return JsonObj;
    }

    removeAllBlankOrNull_asString(JsonObj) {
        $.each(JsonObj, (key, value) => {
            if (value === '' || value === null) {
                delete JsonObj[key];
            } else if (typeof (value) === 'object') {
                JsonObj[key] = this.removeAllBlankOrNull(value);
            } else {
                value = value + '';
            }
        });
        return JsonObj;
    }

    showComunicationMessage() {
        if (this.getCurrentUser().dateInRange) {
            swal({
                title: 'ATENCIÓN',
                html: `
                <p>Estimado cliente:</p>
                <p>La plataforma de Sovos Escontech de facturación electrónica y OSE se actualizará a una versión optimizada, con características que mejorarán su experiencia. La versión actual estará disponible solo hasta el <strong>31 de octubre de 2024</strong>, por lo que le invitamos a estar atento a la información que le estaremos entregando para coordinar de la mejor manera el upgrade de su software.</p>
                <p>Para realizar correctamente la actualización de su usuario, es importante que actualice el campo email de su perfil a una dirección válida y operativa. De no saber cómo realizar dicha actualización, puede ingresar
                 <a href="${this.URL_WS_BACKEND.replace('wsBackend', '')}/#/page/c/U2FsdGVkX1/BC50aNRHeBwcZ70r3xcR00+GJNvESm7uYsEiVN+2fpVVphM2WpwJb"><strong>aquí</strong></a></p>
                <p>Esperamos que este mensaje sea una buena noticia para usted y que juntos preparemos sus sistemas para una mejor operación.</p>
                <p>Si tiene alguna duda, por favor comuníquese a nuestro correo de contacto: <a href="mailto:Contacto-ClientesLatam@sovos.com">Contacto-ClientesLatam@sovos.com</a></p>
                <p>Un cordial saludo,</p>
                <p>Equipo de Sovos Latinoamérica</p>
                `,
                type: 'info',
                showCancelButton: false,
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false, 
                allowEscapeKey: false,     
                allowEnterKey: false      
            });
        }
    }

}





// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/servicios/UtilConfig.ts